/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Rename_Key_TakenInputs */

const en_rename_key_taken = /** @type {(inputs: Rename_Key_TakenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} is already used by a product, a space or a former key.`)
};

const de_rename_key_taken = /** @type {(inputs: Rename_Key_TakenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} wird schon von einem Produkt, einem Bereich oder einem früheren Schlüssel verwendet.`)
};

/**
* | output |
* | --- |
* | "{key} is already used by a product, a space or a former key." |
*
* @param {Rename_Key_TakenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_key_taken = /** @type {((inputs: Rename_Key_TakenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Key_TakenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_key_taken(inputs)
	return en_rename_key_taken(inputs)
});